import { useEffect } from 'react';
/**
 * Custom hook that triggers a callback when user clicks outside the referenced element
 * @param ref - React ref object pointing to the element to detect clicks outside of
 * @param callback - Function to call when click outside is detected
 */ export function useClickOutside(ref, callback) {
    useEffect(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref,
        callback
    ]);
}
